import { CssBaseline } from '@mui/material';
import React from 'react';
import { Outlet, useLocation } from 'react-router';
import logo from '../assets/icons/backuplabs-logo-white.png';
import logoColor from '../assets/icons/backuplabs-logo.png';
import Footer from '../components/Footer/Footer';
import { MyRoot } from '../components/StyledComponents';
import { GlobalAuthStyle } from '../GlobalStyle';
import useWindowDimensions from '../utils/windowDimensions';
// import OnWork from "../views/OnWork/OnWork";

const loginPaths = new Set(['/auth', '/auth/', '/auth/login', '/auth/login/']);

const Auth: React.FC<{isSignUp?: boolean}> = ({ children, isSignUp }) => {
  const { isMobileOnly } = useWindowDimensions();
  const { pathname } = useLocation();
  const headerLogo = !isSignUp && loginPaths.has(pathname) ? logoColor : logo;

  return (
    <MyRoot className='auth-wrapper'>
      <CssBaseline />
      <GlobalAuthStyle ismobile={isMobileOnly}/>
      {/*<OnWork/>*/}
      {!isSignUp && <div/>}
      <div className='auth-content'>
        <Outlet />
      </div>
      {children}
      <Footer/>
    </MyRoot>
  );
};

export default Auth;
